export enum CustomCriteriaType {
  TOGGLE = 'TOGGLE',
  SELECT = 'SELECT',
}
export type CustomCriteriaBase = {
  id: string;
  displayName: string;
  type: CustomCriteriaType;
  userEditable?: boolean;
  enableOnJobRequest?: boolean;
};

export interface CustomCriteriaToggle extends CustomCriteriaBase {
  type: CustomCriteriaType.TOGGLE;
  defaultValueOnJob: boolean;
  defaultValueOnProfile: boolean;
  blockingToggle: boolean;
}

export interface CustomCriteriaSelect extends CustomCriteriaBase {
  type: CustomCriteriaType.SELECT;
  multiple?: boolean;
  options: {
    id: string;
    displayName: string;
  }[];
}

export type CustomCriteriaOnJobBase = {
  id: string;
  displayName: string;
  type: CustomCriteriaType;
};

export interface CustomCriteriaOnJobToggle extends CustomCriteriaOnJobBase {
  type: CustomCriteriaType.TOGGLE;
  value: boolean;
  defaultValueOnJob: boolean;
  defaultValueOnProfile: boolean;
  blockingToggle: boolean;
}

export interface CustomCriteriaOnJobSelect extends CustomCriteriaOnJobBase {
  type: CustomCriteriaType.SELECT;
  values: {
    id: string;
    displayName: string;
  }[];
}

export type CustomCriteriaOnProfileBase = {
  id: string;
  displayName: string;
  type: CustomCriteriaType;
};

export interface CustomCriteriaOnProfileToggle
  extends CustomCriteriaOnProfileBase {
  type: CustomCriteriaType.TOGGLE;
  value: boolean;
}

export interface CustomCriteriaOnProfileSelect
  extends CustomCriteriaOnProfileBase {
  type: CustomCriteriaType.SELECT;
  values: {
    id: string;
    displayName: string;
  }[];
}

export type CustomCriteria = CustomCriteriaToggle | CustomCriteriaSelect;

export type CustomCriteriaOnJob =
  | CustomCriteriaOnJobToggle
  | CustomCriteriaOnJobSelect;

export type CustomCriteriaOnProfile =
  | CustomCriteriaOnProfileToggle
  | CustomCriteriaOnProfileSelect;
